<template>
  <div id="sliderMarks" class="slider" :class="{ finalFilter: this.finalFilter }">
    <div class="border">
      <vue-slider 
        v-model="value" 
        :data="data" 
        :marks="true" 
        :tooltip-formatter="formatTooltip"
        v-on:change="getSelectedValueWhithDebounce" 
        ref="slider" 
        :clickable="allowsInteraction" 
        @change="getSelectedValueWhithDebounce('change')"
        @drag-end="getSelectedValueWhithDebounce('drag-end')" 
        @drag-start="getSelectedValueWhithDebounce('drag-start')" 
        :key="keyReRender"
        class="range-slider-inch">
      </vue-slider>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import VueSlider from "vue-slider-component"; // https://nightcatsama.github.io/vue-slider-component/#/
import { getSizes } from "../utils/dataHandler";

export default {
  name: "RangeSliderMarks",
  components: {
    VueSlider,
  },
  watch: {
    sizesfinalFilter(valueSizesFinalFilter) {
      this.data = valueSizesFinalFilter.map((size) => `${size}”`);
      this.formatTooltip = (value) => `${value}”`;
      this.value = [
        `${valueSizesFinalFilter[0]}”`,
        `${valueSizesFinalFilter[valueSizesFinalFilter.length - 1]}”`
      ];

      this.keyReRender += 1
    },
    openFinalFilters(value) {
      if (value) {
        this.handleSliderIsAnimated("finalFilters");
      }
    },
    userChoices() {
      if (this.finalFilter) {
        this.keyReRender += 1
      }
    }
  },
  props: ["sendAnalytics", "userChoices", "finalFilter", "sizesfinalFilter", "allowsIteration", "openFinalFilters"],
  data() {
    const sizes = getSizes({
      passion: this.userChoices.passionSelected,
      feature: this.userChoices.featureSelected
    });

    const value =
      Array.isArray(this.userChoices.inchSelected)
        ? this.userChoices.inchSelected.map((i) => `${i}”`)
        : [
          `${sizes[0]}”`,
          `${sizes[sizes.length - 1]}”`
        ];

    return {
      value: value,
      selectedValue: 0,
      formatTooltip: (value) => `${value}”`,
      data: sizes.map((size) => `${size}”`),
      allowsInteraction: false,
      sizes: sizes,
      keyReRender: 0,
      showToastError: true,
    };
  },
  computed: {},
  mounted() {
    const divborder = document.querySelector("div.border")
    divborder.classList.add("overlayBorder")

    this.handleSliderIsAnimated();

    if (!this.finalFilter) {
      this.$emit('selectInch', this.value.map((v) => v.replace('”', '')));
    }
  },
  methods: {
    getSelectedValueWhithDebounce(event){
      return this.debounce(() => this.getSelectedValue(event))
    },
    debounce(callback, timeout = 500){
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(callback, timeout);
    },
    getSelectedValue(event) {
      if (this.finalFilter && !this.allowsIteration && this.userChoices.passionSelected !== 'todos') {
        if (event === 'drag-start') {
          this.showToastError = false;
        }
        if (event === 'drag-end') {
          this.showToastError = true;
        }

        if (this.showToastError) {
          Vue.$toast.clear();
          Vue.$toast.open({
            message: 'Informe todas as preferências antes de escolher um tamanho',
            type: 'error',
            position: 'bottom-right'
          });
        }

        this.value = this.userChoices.inchSelected.map((i) => `${i}”`);
      } else {
        const rawValue = this.value.map((v) => v.replace('”', ''));

        window.dataLayer.push({
          event: "gtm.tamanho_tv",
          target: "gtm-more",
          action: "click",
          tamanho: rawValue.join(),
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        const eventName = this.finalFilter ? 'selectInchFinalFilter' : 'selectInch';

        this.$emit(eventName, rawValue);
      }
    },
    handleSliderIsAnimated(screen = null) {
      const vueSliderProgress = document.querySelector('.range-slider-inch .vue-slider-process');
      vueSliderProgress.classList.add('vue-slider-custom-animation-marks');

      const vueSliderDot = document.querySelector('.range-slider-inch .vue-slider-dot:last-child');
      vueSliderDot.classList.add('vue-slider-dot-custom-animation-marks');

      const divborder = document.querySelector("div.border")
      divborder.classList.add(screen === 'finalFilters' ? "overlayBorderFinalFilter" : "overlayBorder")

      const isAnimated = this.value[0].replace('”', '') === this.sizes[0];

      if (!isAnimated) {
        vueSliderProgress.classList.remove('vue-slider-custom-animation-marks');
        vueSliderDot.classList.remove('vue-slider-dot-custom-animation-marks');
      }

      if (screen === "finalFilters") {
        setTimeout(() => {
          divborder.classList.remove("overlayBorderFinalFilter")
          this.allowsInteraction = true;
        }, 3500);
      } else {
        setTimeout(() => {
          divborder.classList.remove("overlayBorder")
          this.allowsInteraction = true;
        }, 3500);
      }
    }

    // vueSliderEffect(){
    //   var cssAnimation = document.createElement('style');

    //   //THIS CODE IS ABLE TO ALLOW THE WIDTH OF THE ANIMATION ELEMENT TO BE DYNAMIC
    //   var keyFramesMarksMove = document.createTextNode('@keyframes MarksMove {'+
    //     `0%   {width: 100%;}`+
    //     '50%  {width: 0;}'+
    //     '100% {width: 100%;}'+
    //   '}');

    //   var keyFramesDotAnimation = document.createTextNode('@keyframes dotAnimation {'+
    //     `0%   {left: 100%;}`+
    //     '50%  {left: 0;}'+
    //     '100% {left: 100%;}'+
    //   '}');

    //   cssAnimation.appendChild(keyFramesMarksMove);
    //   cssAnimation.appendChild(keyFramesDotAnimation);

    //   document.getElementsByTagName("head")[0].appendChild(cssAnimation);
    // }
  },
};
</script>

<style lang="scss">
@import "../sass/ranger-slider.mixin.scss";
@include vue-slider-component-styles;

.vue-slider-mark-label,
.vue-slider-mark-label-active {
  margin-top: 30px !important;
  font-weight: bold !important;

  // font-size: 20px !important;
}

#sliderMarks {

  .vue-slider-dot-tooltip-inner,
  .vue-slider-dot-tooltip-inner-top {
    display: none;
  }
}

@import "~vue-slider-component/lib/theme/default.scss";

.finalFilter {
  margin-top: 1.5rem !important;

  .border {
    height: 80px;

    .vue-slider {
      margin: 2rem 2.5rem;
      padding: 0;

      .vue-slider-rail {
        .vue-slider-process {
          padding: 4px;
        }

        .vue-slider-dot {
          margin-top: 2px;
        }

        .vue-slider-marks {
          .vue-slider-mark {
            .vue-slider-mark-label {
              padding-top: 1.1rem !important;
              font-family: $font-family-default-bold;
              font-size: 1.5rem;
            }
          }
        }
      }
    }
  }
}

.slider {
  text-align: center;

  .border {
    width: 700px;
    background-color: #97bde0;
    background: linear-gradient(to right,
        #f9e29d 0%,
        #c5ddb5 50.31%,
        #97bde0 100%);
    padding: 15px 25px;
    border-radius: 160px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
}

.vue-slider-ltr div.vue-slider-mark-label {
  left: 4px;
  position: relative;
  width: 20px;
}

.vue-slider-mark-label {

  &::before {
    content: "";
    display: block;
    height: 9px;
    width: 2px;
    border-radius: 2px;
    background: #fff;
    position: absolute;
    left: 7px;
    top: -9px;
  }
}

.vue-slider-mark-label-active {
  &::before {
    content: "";
    background: #000;
  }
}

.vue-slider-custom-animation-marks {
  transition-timing-function: ease-in;
  animation: MarksMove 3s;
}

.overlayBorder {
  position: relative;
}

div.overlayBorder:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 6;
  background: transparent;
}

.overlayBorderFinalFilter {
  position: relative;
}

div.overlayBorderFinalFilter:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 6;
  background: transparent;
}

.vue-slider-dot-custom-animation-marks {
  transition-timing-function: ease-in;
  animation: dotAnimation 3s;
}

@keyframes MarksMove {
  0% {
    width: 100%;
  }

  50% {
    width: 0;
  }

  100% {
    width: 100%;
  }
}

@keyframes dotAnimation {
  0% {
    left: 100%;
  }

  50% {
    left: 0;
  }

  100% {
    left: 100%;
  }
}

@media (min-width: 768px) and (max-width: 990px) {
  .slider {
    .border {
      width: 500px;
    }
  }
}

@media (max-width: $bp-mobile) {
  .slider {
    margin: 0 auto;
    box-sizing: border-box;

    .border {
      max-width: calc(90vw);
      // border-radius: 0;
    }
  }

  .finalFilter {
    width: 100% !important;

    .border {
      border-radius: 0 !important;
      width: 100% !important;
      max-width: 100% !important;

      .vue-slider {
        margin: 1.1rem 1rem;

        .vue-slider-rail {
          .vue-slider-marks {
            .vue-slider-mark {
              .vue-slider-mark-label::before {
                top: 7px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 325px) {
  .slider {
    .border {
      max-width: calc(100vw);
      border-radius: 0;
    }
  }
}

@media (max-width: 520px) {
  .finalFilter {
    .border {
      .vue-slider {
        .vue-slider-rail {
          .vue-slider-marks {
            .vue-slider-mark {
              .vue-slider-mark-label {
                font-size: 0.875rem;
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 769px) {
  .finalFilter {
    margin: 1.5rem 0 !important;
    width: 100%;

    .border {
      height: 50px;
      width: 100% !important;

      .vue-slider {
        margin: 0;

        .vue-slider-rail {
          .vue-slider-marks {
            .vue-slider-mark {
              .vue-slider-mark-label {
                padding-top: .3rem !important;
                font-family: $font-family-default-bold;
                font-size: 1.3rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
